/* Robust image switcher for product pages:
   - Shows the correct image on FIRST LOAD and on option change
   - Supports pages WITH or WITHOUT a 'window' option
   - Uses either explicit map or a smart fallback that matches your .hide_* image classes
*/
(function($){
  $(function(){

    // ---------- helpers ----------
    function norm(s){return (s||"").toString()
      .replace(/[“”]/g,'"').replace(/[’]/g,"'")
      .replace(/\s+/g," ").trim();}

    // Turn "DL - 220mm x 110mm x 35mm" or "180mm x 235mm" into "220x110x35mm" / "180x235mm"
    function sizeToken(sizeText){
      const t = norm(sizeText).toLowerCase();
      const m3 = t.match(/(\d+)\s*mm\s*x\s*(\d+)\s*mm\s*x\s*(\d+)\s*mm/);
      if (m3) return `${m3[1]}x${m3[2]}x${m3[3]}mm`;
      const m2 = t.match(/(\d+)\s*mm\s*x\s*(\d+)\s*mm/);
      if (m2) return `${m2[1]}x${m2[2]}mm`;
      const mc = t.match(/(\d+x\d+(x\d+)?)mm/);
      return mc ? mc[0] : t;
    }

    // Map print text to preferred class suffix order
    function printSuffixes(printText){
      const p = norm(printText).toLowerCase();
      if (p.includes("front & rear")) return ["_bothsides","_both","_front_rear","_frontrear","_front","_rear"];
      if (p.includes("rear side only")) return ["_rear","_front_rear","_frontrear","_bothsides","_both","_front"];
      // default: front side only
      return ["_front","_front_rear","_frontrear","_bothsides","_both","_rear"];
    }

    // Map window option to tag found in class names
    function windowTag(windowText){
      const w = norm(windowText).toLowerCase();
      if (!w) return null;
      if (w.includes("high window")) return "_hw_";
      if (w.includes("non-window")) return "_nw_";
      if (w.includes("window")) return "_w_";
      return null;
    }

    // Optional explicit map (use it where you want exact control; otherwise fallback handles it)
    const map = {
      "Front Side Only|180mm x 235mm": ".hide_180x235mm_front",
      "Rear Side Only|180mm x 235mm": ".hide_180x235mm_rear",
      "Front & Rear Sides|180mm x 235mm": ".hide_180x235mm_bothsides",
      "Front Side Only|194mm x 292mm": ".hide_194x292mm_front",
      "Rear Side Only|194mm x 292mm": ".hide_194x292mm_rear",
      "Front & Rear Sides|194mm x 292mm": ".hide_194x292mm_bothsides",
      "Front Side Only|234mm x 334mm": ".hide_234x334mm_front",
      "Rear Side Only|234mm x 334mm": ".hide_234x334mm_rear",
      "Front & Rear Sides|234mm x 334mm": ".hide_234x334mm_bothsides",
      "Front Side Only|249mm x 352mm": ".hide_249x352mm_front",
      "Rear Side Only|249mm x 352mm": ".hide_249x352mm_rear",
      "Front & Rear Sides|249mm x 352mm": ".hide_249x352mm_bothsides",
      "Front Side Only|278mm x 400mm": ".hide_278x400mm_front",
      "Rear Side Only|278mm x 400mm": ".hide_278x400mm_rear",
      "Front & Rear Sides|278mm x 400mm": ".hide_278x400mm_bothsides",
      "Front Side Only|250mm x 150mm": ".hide_250x150mm_front",
      "Rear Side Only|250mm x 150mm": ".hide_250x150mm_rear",
      "Front & Rear Sides|250mm x 150mm": ".hide_250x150mm_bothsides",
      "Front Side Only|270mm x 185mm": ".hide_270x185mm_front",
      "Rear Side Only|270mm x 185mm": ".hide_270x185mm_rear",
      "Front & Rear Sides|270mm x 185mm": ".hide_270x185mm_bothsides",
      "Front Side Only|340mm x 235mm": ".hide_340x235mm_front",
      "Rear Side Only|340mm x 235mm": ".hide_340x235mm_rear",
      "Front & Rear Sides|340mm x 235mm": ".hide_340x235mm_bothsides",
      "Front Side Only|360mm x 250mm": ".hide_360x250mm_front",
      "Rear Side Only|360mm x 250mm": ".hide_360x250mm_rear",
      "Front & Rear Sides|360mm x 250mm": ".hide_360x250mm_bothsides",
      "100mm x 165mm|Front Side Only": ".hide_100x165mm_front",
      "100mm x 165mm|Rear Side Only": ".hide_100x165mm_rear",
      "100mm x 165mm|Front & Rear Sides": ".hide_100x165mm_bothsides",
      "120mm x 215mm|Front Side Only": ".hide_120x215mm_front",
      "120mm x 215mm|Rear Side Only": ".hide_120x215mm_rear",
      "120mm x 215mm|Front & Rear Sides": ".hide_120x215mm_bothsides",
      "150mm x 215mm|Front Side Only": ".hide_150x215mm_front",
      "150mm x 215mm|Rear Side Only": ".hide_150x215mm_rear",
      "150mm x 215mm|Front & Rear Sides": ".hide_150x215mm_bothsides",
      "180mm x 265mm|Front Side Only": ".hide_180x265mm_front",
      "180mm x 265mm|Rear Side Only": ".hide_180x265mm_rear",
      "180mm x 265mm|Front & Rear Sides": ".hide_180x265mm_bothsides",
      "220mm x 265mm|Front Side Only": ".hide_220x265mm_front",
      "220mm x 265mm|Rear Side Only": ".hide_220x265mm_rear",
      "220mm x 265mm|Front & Rear Sides": ".hide_220x265mm_bothsides",
      "220mm x 340mm|Front Side Only": ".hide_220x340mm_front",
      "220mm x 340mm|Rear Side Only": ".hide_220x340mm_rear",
      "220mm x 340mm|Front & Rear Sides": ".hide_220x340mm_bothsides",
      "230mm x 340mm|Front Side Only": ".hide_230x340mm_front",
      "230mm x 340mm|Rear Side Only": ".hide_230x340mm_rear",
      "230mm x 340mm|Front & Rear Sides": ".hide_230x340mm_bothsides",
      "240mm x 340mm|Front Side Only": ".hide_honey_240x340mm_front",
      "240mm x 340mm|Rear Side Only": ".hide_honey_240x340mm_rear",
      "240mm x 340mm|Front & Rear Sides": ".hide_honey_240x340mm_bothsides",
      "270mm x 360mm|Front Side Only": ".hide_270x360mm_front",
      "270mm x 360mm|Rear Side Only": ".hide_270x360mm_rear",
      "270mm x 360mm|Front & Rear Sides": ".hide_270x360mm_bothsides",
      "300mm x 445mm|Front Side Only": ".hide_300x445mm_front",
      "300mm x 445mm|Rear Side Only": ".hide_300x445mm_rear",
      "300mm x 445mm|Front & Rear Sides": ".hide_300x445mm_bothsides",
      "350mm x 470mm|Front Side Only": ".hide_350x470mm_front",
      "350mm x 470mm|Rear Side Only": ".hide_350x470mm_rear",
      "350mm x 470mm|Front & Rear Sides": ".hide_350x470mm_bothsides",
      "120mm x 165mm|Front Side Only": ".hide_120x165mm_front",
      "120mm x 165mm|Rear Side Only": ".hide_120x165mm_rear",
      "120mm x 165mm|Front & Rear Sides": ".hide_120x165mm_bothsides",
      "230mm x 335mm|Front Side Only": ".hide_230x335mm_front",
      "230mm x 335mm|Rear Side Only": ".hide_230x335mm_rear",
      "230mm x 335mm|Front & Rear Sides": ".hide_230x335mm_bothsides",
      "240mm x 335mm|Front Side Only": ".hide_240x335mm_front",
      "240mm x 335mm|Rear Side Only": ".hide_240x335mm_rear",
      "240mm x 335mm|Front & Rear Sides": ".hide_240x335mm_bothsides",
      "Front Side Only|DL - 220mm x 110mm x 35mm": ".hide_220x110x35mm_front_rear",
      "Rear Side Only|DL - 220mm x 110mm x 35mm": ".hide_220x110x35mm_front_rear",
      "Front & Rear Sides|DL - 220mm x 110mm x 35mm": ".hide_220x110x35mm_bothsides",
      "Front Side Only|C5 - 229mm x 162mm x 35mm": ".hide_229x162x35mm_front_rear",
      "Rear Side Only|C5 - 229mm x 162mm x 35mm": ".hide_229x162x35mm_front_rear",
      "Front & Rear Sides|C5 - 229mm x 162mm x 35mm": ".hide_229x162x35mm_bothsides",
      "Front Side Only|C6 - 162mm x 114mm x 35mm": ".hide_162x114x35mm_front_rear",
      "Rear Side Only|C6 - 162mm x 114mm x 35mm": ".hide_162x114x35mm_front_rear",
      "Front & Rear Sides|C6 - 162mm x 114mm x 35mm": ".hide_162x114x35mm_bothsides",
      "DL+ - 114mm x 235mm - Box Of 500|Non-Windowed": ".hide_114x235mm_nw_frank",
      "DL+ - 114mm x 235mm - Box Of 500|Windowed": ".hide_114x235mm_w_frank",
      "C5+ - 162mm x 235mm - Box Of 500|Windowed": ".hide_162x235mm_w_frank",
      "C5+ - 162mm x 235mm - Box Of 500|Non-Windowed": ".hide_162x235mm_nw_frank",
      "C5+ - 162mm x 235mm - Box Of 500|High Windowed": ".hide_162x235mm_hw_frank",
      "DL - 110mm x 220mm - Box Of 1000|Non-Windowed": ".hide_110x220mm_nw_frank",
      "DL - 110mm x 220mm - Box Of 1000|Windowed": ".hide_110x220mm_w_frank",
      "C5 - 162mm x 229mm - Box Of 500|Windowed": ".hide_162x229mm_w_frank",
      "C5 - 162mm x 229mm - Box Of 500|Non-Windowed": ".hide_162x229mm_nw_frank",
      "C4 - 324mm x 229mm - Box Of 500|Windowed": ".hide_324x229mm_w_frank",
      "C4 - 324mm x 229mm - Box Of 500|Non-Windowed": ".hide_324x229mm_nw_frank",
      "Front Side Only|DL+ - 114mm x 235mm - Box Of 500|Non-Windowed": ".hide_114x235mm_nw_front",
      "Rear Side Only|DL+ - 114mm x 235mm - Box Of 500|Non-Windowed": ".hide_114x235mm_nw_rear",
      "Front & Rear Sides|DL+ - 114mm x 235mm - Box Of 500|Non-Windowed": ".hide_114x235mm_nw_bothsides",
      "Front Side Only|DL+ - 114mm x 235mm - Box Of 500|Windowed": ".hide_114x235mm_w_front",
      "Rear Side Only|DL+ - 114mm x 235mm - Box Of 500|Windowed": ".hide_114x235mm_w_rear",
      "Front & Rear Sides|DL+ - 114mm x 235mm - Box Of 500|Windowed": ".hide_114x235mm_w_bothsides",
      "Front Side Only|C5+ - 162mm x 235mm - Box Of 500|Non-Windowed": ".hide_162x235mm_nw_front",
      "Rear Side Only|C5+ - 162mm x 235mm - Box Of 500|Non-Windowed": ".hide_162x235mm_nw_rear",
      "Front & Rear Sides|C5+ - 162mm x 235mm - Box Of 500|Non-Windowed": ".hide_162x235mm_nw_bothsides",
      "Front Side Only|C5+ - 162mm x 235mm - Box Of 500|Windowed": ".hide_162x235mm_w_front",
      "Rear Side Only|C5+ - 162mm x 235mm - Box Of 500|Windowed": ".hide_162x235mm_w_rear",
      "Front & Rear Sides|C5+ - 162mm x 235mm - Box Of 500|Windowed": ".hide_162x235mm_w_bothsides",
      "Front Side Only|C5+ - 162mm x 235mm - Box Of 500|High Windowed": ".hide_162x235mm_hw_front",
      "Rear Side Only|C5+ - 162mm x 235mm - Box Of 500|High Windowed": ".hide_162x235mm_hw_rear",
      "Front & Rear Sides|C5+ - 162mm x 235mm - Box Of 500|High Windowed": ".hide_162x235mm_hw_bothsides",
      "Front Side Only|DL+ - 114mm x 235mm|Non-Windowed": ".hide_114x235mm_nw_front",
      "Rear Side Only|DL+ - 114mm x 235mm|Non-Windowed": ".hide_114x235mm_nw_rear",
      "Front & Rear Sides|DL+ - 114mm x 235mm|Non-Windowed": ".hide_114x235mm_nw_bothsides",
      "Front Side Only|DL+ - 114mm x 235mm|Windowed": ".hide_114x235mm_w_front",
      "Rear Side Only|DL+ - 114mm x 235mm|Windowed": ".hide_114x235mm_w_rear",
      "Front & Rear Sides|DL+ - 114mm x 235mm|Windowed": ".hide_114x235mm_w_bothsides",
      "Front Side Only|C5+ - 162mm x 235mm|Non-Windowed": ".hide_162x235mm_nw_front",
      "Rear Side Only|C5+ - 162mm x 235mm|Non-Windowed": ".hide_162x235mm_nw_rear",
      "Front & Rear Sides|C5+ - 162mm x 235mm|Non-Windowed": ".hide_162x235mm_nw_bothsides",
      "Front Side Only|C5+ - 162mm x 235mm|Windowed": ".hide_162x235mm_w_front",
      "Rear Side Only|C5+ - 162mm x 235mm|Windowed": ".hide_162x235mm_w_rear",
      "Front & Rear Sides|C5+ - 162mm x 235mm|Windowed": ".hide_162x235mm_w_bothsides",
      "Front Side Only|C5+ - 162mm x 235mm|High Windowed": ".hide_162x235mm_hw_front",
      "Rear Side Only|C5+ - 162mm x 235mm|High Windowed": ".hide_162x235mm_hw_rear",
      "Front & Rear Sides|C5+ - 162mm x 235mm|High Windowed": ".hide_162x235mm_hw_bothsides",
      "Front Side Only|DL - 110mm x 220mm - Box Of 500|Non-Windowed": ".hide_110x220mm_nw_front",
      "Rear Side Only|DL - 110mm x 220mm - Box Of 500|Non-Windowed": ".hide_110x220mm_nw_rear",
      "Front & Rear Sides|DL - 110mm x 220mm - Box Of 500|Non-Windowed": ".hide_110x220mm_nw_bothsides",
      "Front Side Only|DL - 110mm x 220mm - Box Of 500|Windowed": ".hide_110x220mm_w_front",
      "Rear Side Only|DL - 110mm x 220mm - Box Of 500|Windowed": ".hide_110x220mm_w_rear",
      "Front & Rear Sides|DL - 110mm x 220mm - Box Of 500|Windowed": ".hide_110x220mm_w_bothsides",
      "Front Side Only|C5 - 162mm x 229mm - Box Of 500|Non-Windowed": ".hide_162x229mm_nw_front",
      "Rear Side Only|C5 - 162mm x 229mm - Box Of 500|Non-Windowed": ".hide_162x229mm_nw_rear",
      "Front & Rear Sides|C5 - 162mm x 229mm - Box Of 500|Non-Windowed": ".hide_162x229mm_nw_bothsides",
      "Front Side Only|C5 - 162mm x 229mm - Box Of 500|Windowed": ".hide_162x229mm_w_front",
      "Rear Side Only|C5 - 162mm x 229mm - Box Of 500|Windowed": ".hide_162x229mm_w_rear",
      "Front & Rear Sides|C5 - 162mm x 229mm - Box Of 500|Windowed": ".hide_162x229mm_w_bothsides",
      "Front Side Only|DL - 110mm x 220mm|Non-Windowed": ".hide_110x220mm_nw_front",
      "Rear Side Only|DL - 110mm x 220mm|Non-Windowed": ".hide_110x220mm_nw_rear",
      "Front & Rear Sides|DL - 110mm x 220mm|Non-Windowed": ".hide_110x220mm_nw_bothsides",
      "Front Side Only|DL - 110mm x 220mm|Windowed": ".hide_110x220mm_w_front",
      "Rear Side Only|DL - 110mm x 220mm|Windowed": ".hide_110x220mm_w_rear",
      "Front & Rear Sides|DL - 110mm x 220mm|Windowed": ".hide_110x220mm_w_bothsides",
      "Front Side Only|C5 - 162mm x 229mm|Non-Windowed": ".hide_162x229mm_nw_front",
      "Rear Side Only|C5 - 162mm x 229mm|Non-Windowed": ".hide_162x229mm_nw_rear",
      "Front & Rear Sides|C5 - 162mm x 229mm|Non-Windowed": ".hide_162x229mm_nw_bothsides",
      "Front Side Only|C5 - 162mm x 229mm|Windowed": ".hide_162x229mm_w_front",
      "Rear Side Only|C5 - 162mm x 229mm|Windowed": ".hide_162x229mm_w_rear",
      "Front & Rear Sides|C5 - 162mm x 229mm|Windowed": ".hide_162x229mm_w_bothsides",
      "Front Side Only|C4 - 324mm x 229mm - Box Of 500|Non-Windowed": ".hide_324x229mm_nw_front",
      "Rear Side Only|C4 - 324mm x 229mm - Box Of 500|Non-Windowed": ".hide_324x229mm_nw_rear",
      "Front & Rear Sides|C4 - 324mm x 229mm - Box Of 500|Non-Windowed": ".hide_324x229mm_nw_bothsides",
      "Front Side Only|C4 - 324mm x 229mm - Box Of 500|Windowed": ".hide_324x229mm_w_front",
      "Rear Side Only|C4 - 324mm x 229mm - Box Of 500|Windowed": ".hide_324x229mm_w_rear",
      "Front & Rear Sides|C4 - 324mm x 229mm - Box Of 500|Windowed": ".hide_324x229mm_w_bothsides",
      "Front Side Only|C4 - 324mm x 229mm|Non-Windowed": ".hide_324x229mm_nw_front",
      "Rear Side Only|C4 - 324mm x 229mm|Non-Windowed": ".hide_324x229mm_nw_rear",
      "Front & Rear Sides|C4 - 324mm x 229mm|Non-Windowed": ".hide_324x229mm_nw_bothsides",
      "Front Side Only|C4 - 324mm x 229mm|Windowed": ".hide_324x229mm_w_front",
      "Rear Side Only|C4 - 324mm x 229mm|Windowed": ".hide_324x229mm_w_rear",
      "Front & Rear Sides|C4 - 324mm x 229mm|Windowed": ".hide_324x229mm_w_bothsides",
      "DL - 114mm x 235mm - Box Of 1000|Non-Windowed": ".hide_114x235mm_nw_frank",
      "DL - 114mm x 235mm - Box Of 1000|Windowed": ".hide_114x235mm_w_frank",
      "C5 - 162mm x 235mm - Box Of 500|Windowed": ".hide_162x235mm_w_frank",
      "C5 - 162mm x 235mm - Box Of 500|Non-Windowed": ".hide_162x235mm_nw_frank",
      "C5 - 162mm x 235mm - Box Of 500|High Windowed": ".hide_162x235mm_hw_frank",
      "Front Side Only|DL - 114mm x 235mm - Box Of 1000|Non-Windowed": ".hide_114x235mm_nw_front",
      "Rear Side Only|DL - 114mm x 235mm - Box Of 1000|Non-Windowed": ".hide_114x235mm_nw_rear",
      "Front & Rear Sides|DL - 114mm x 235mm - Box Of 1000|Non-Windowed": ".hide_114x235mm_nw_bothsides",
      "Front Side Only|DL - 114mm x 235mm - Box Of 1000|Windowed": ".hide_114x235mm_w_front",
      "Rear Side Only|DL - 114mm x 235mm - Box Of 1000|Windowed": ".hide_114x235mm_w_rear",
      "Front & Rear Sides|DL - 114mm x 235mm - Box Of 1000|Windowed": ".hide_114x235mm_w_bothsides",
      "Front Side Only|C5 - 162mm x 235mm - Box Of 500|Non-Windowed": ".hide_162x235mm_nw_front",
      "Rear Side Only|C5 - 162mm x 235mm - Box Of 500|Non-Windowed": ".hide_162x235mm_nw_rear",
      "Front & Rear Sides|C5 - 162mm x 235mm - Box Of 500|Non-Windowed": ".hide_162x235mm_nw_bothsides",
      "Front Side Only|C5 - 162mm x 235mm - Box Of 500|Windowed": ".hide_162x235mm_w_front",
      "Rear Side Only|C5 - 162mm x 235mm - Box Of 500|Windowed": ".hide_162x235mm_w_rear",
      "Front & Rear Sides|C5 - 162mm x 235mm - Box Of 500|Windowed": ".hide_162x235mm_w_bothsides",
      "Front Side Only|C5 - 162mm x 235mm - Box Of 500|High Windowed": ".hide_162x235mm_hw_front",
      "Rear Side Only|C5 - 162mm x 235mm - Box Of 500|High Windowed": ".hide_162x235mm_hw_rear",
      "Front & Rear Sides|C5 - 162mm x 235mm - Box Of 500|High Windowed": ".hide_162x235mm_hw_bothsides",
      "Front Side Only|DL - 110mm x 220mm - Box Of 1000|Non-Windowed": ".hide_110x220mm_nw_front",
      "Rear Side Only|DL - 110mm x 220mm - Box Of 1000|Non-Windowed": ".hide_110x220mm_nw_rear",
      "Front & Rear Sides|DL - 110mm x 220mm - Box Of 1000|Non-Windowed": ".hide_110x220mm_nw_bothsides",
      "Front Side Only|DL - 110mm x 220mm - Box Of 1000|Windowed": ".hide_110x220mm_w_front",
      "Rear Side Only|DL - 110mm x 220mm - Box Of 1000|Windowed": ".hide_110x220mm_w_rear",
      "Front & Rear Sides|DL - 110mm x 220mm - Box Of 1000|Windowed": ".hide_110x220mm_w_bothsides"
    };

    // Generic fallbacks (cover your various products’ generic images)
    const genericFallback = ".hide_pillow_dimensions, .hide_padded_mailer, .hide_pcket_dimensions, .hide_dimensions, .hide_generic_dimensions, .hide_cap_dimensions, .hide_gummed_dimensions, .hide_self_seal_dimensions";

    function showOnly(selector){
      // Use *contains* not *starts-with* so images with multiple classes still get hidden
      $("[class*='hide_']").hide();
      if (selector) { $(selector).show(); }
      else { $(genericFallback).show(); }
    }

    function findExplicit(size, print, windowOpt){
      // Try explicit map in several safe orders; skip window if empty
      const keys = [];
      if (windowOpt) {
        keys.push(`${print}|${size}|${windowOpt}`, `${size}|${print}|${windowOpt}`);
      }
      keys.push(`${print}|${size}`, `${size}|${print}`, size);
      for (const k of keys) if (map[k]) return map[k];
      return null;
    }

    function findByHeuristics(size, print, windowOpt){
      const token = sizeToken(size);                    // e.g. "220x110x35mm"
      const wtag  = windowTag(windowOpt);              // "_w_" / "_nw_" / "_hw_" / null
      const suffixes = printSuffixes(print);

      // Images that look like the right size (any class containing token)
      let $pool = $("[class*='hide_']").filter(function(){
        return this.className.toLowerCase().includes(token);
      });

      if ($pool.length === 0) return null;

      // If window tag is relevant, narrow to those classes
      if (wtag){
        const narrowed = $pool.filter(function(){ return this.className.toLowerCase().includes(wtag); });
        if (narrowed.length) $pool = narrowed;
      }

      // Prefer best-matching print suffix
      for (const suf of suffixes){
        const pick = $pool.filter(function(){ return this.className.toLowerCase().includes(suf); }).first();
        if (pick.length){
          const cls = pick[0].className.split(/\s+/).find(c => c.indexOf("hide_") === 0);
          return cls ? "." + cls : null;
        }
      }

      // Otherwise, just return the first size match
      const first = $pool.first();
      if (first.length){
        const cls = first[0].className.split(/\s+/).find(c => c.indexOf("hide_") === 0);
        return cls ? "." + cls : null;
      }
      return null;
    }

    function updateImages(){
      const size      = norm($('.size_class').val());
      const print     = norm($('.print_class').val());
      const windowOpt = norm($('.window_class').val());

      // If we don't even have size/print yet, defer
      if (!size || !print) return;

      // Try explicit → then heuristic
      const explicit = findExplicit(size, print, windowOpt);
      const target   = explicit || findByHeuristics(size, print, windowOpt);

      showOnly(target);
    }

    // ---------- robust init & events ----------
    // 1) Run on change
    $(document).on('change', '.size_class, .print_class, .window_class', updateImages);

    // 2) Hook Shopify events if available
    document.addEventListener('variant:loaded', updateImages);
    document.addEventListener('variant:change', updateImages);
    document.addEventListener('shopify:section:load', updateImages);

    // 3) Observe DOM mutations (themes often re-render options/images after load)
    const mo = new MutationObserver(function(){
      clearTimeout(mo._t);
      mo._t = setTimeout(updateImages, 50);
    });
    mo.observe(document.documentElement, {subtree:true, childList:true, attributes:true});

    // 4) Initial run: wait until selects AND at least one .hide_ image exist
    (function boot(waitMsLeft){
      const selectsReady = $('.size_class').length && $('.print_class').length;
      const imagesReady  = $("[class*='hide_']").length > 0;
      if (selectsReady && imagesReady) {
        // Let the theme finish its own first paint and variant init
        requestAnimationFrame(function(){ requestAnimationFrame(updateImages); });
      } else {
        if (waitMsLeft <= 0) { updateImages(); return; }
        setTimeout(function(){ boot(waitMsLeft - 100); }, 100);
      }
    })(3000); // retry up to ~3s

  });
})(window.jQuery || window.$);